import * as Sentry from "@sentry/remix";
import React, { useState, useEffect } from "react";
import { CacheProvider } from "@emotion/react";
import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { ClientStyleContext } from "./context";
import createEmotionCache from "./createEmotionCache";
import { hydrate } from "react-dom";
import { StorageService } from "./utils/StorageUtils";

Sentry.init({
  dsn: "https://97c2a4bd47efd00f5a4f0418af955f3b@o4509716694827008.ingest.de.sentry.io/4509823919063120",
  tracesSampleRate: 0.1,

  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: true,
      networkDetailAllowUrls: [/./],
      networkRequestHeaders: ["X-Custom-Header"],
      networkResponseHeaders: ["X-Custom-Header"],
      stickySession: false,
      minReplayDuration: 5000,
    }),
    Sentry.breadcrumbsIntegration({
      console: false,
    }),
  ],

  beforeSend(event) {
    if (StorageService.getItem("sentryAllowed") == true) {
      return event;
    }
    return null;
  },

  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1,
});

function ClientCacheProvider({ children }) {
  const [cache, setCache] = useState(createEmotionCache());

  function reset() {
    setCache(createEmotionCache());
  }

  return (
    <ClientStyleContext.Provider value={{ reset }}>
      <CacheProvider value={cache}>{children}</CacheProvider>
    </ClientStyleContext.Provider>
  );
}

function sendPageView(url) {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "page_view", {
      page_path: url,
    });
  }
}

hydrate(
  <ClientCacheProvider>
    <RemixBrowser />
  </ClientCacheProvider>,
  document
);

// Listen for route changes to send page views to Google Analytics
document.addEventListener("remix:navigation", (event) => {
  sendPageView(event.detail?.to);
});

// You can also send the page view for the initial load
if (typeof window !== "undefined") {
  sendPageView(window.location.pathname);
}
